"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

// Hide the PostHog Support widget on focus-heavy routes where a floating chat
// bubble would be a distraction. Everywhere else it stays visible.
const HIDE_PATTERNS = [/^\/study(\/|$)/, /^\/session-complete(\/|$)/, /^\/export(\/|$)/];

function shouldHide(pathname: string) {
  return HIDE_PATTERNS.some((re) => re.test(pathname));
}

export function PostHogSupportVisibility() {
  const pathname = usePathname();

  useEffect(() => {
    const hide = shouldHide(pathname);

    const apply = () => {
      const c = window.posthog?.conversations;
      if (!c) return false;
      if (hide) c.hide();
      else c.show();
      return true;
    };

    if (apply()) return;

    let attempts = 0;
    const interval = setInterval(() => {
      attempts++;
      if (apply() || attempts >= 50) clearInterval(interval);
    }, 100);
    return () => clearInterval(interval);
  }, [pathname]);

  return null;
}
